import { useEffect, useRef } from 'react';

import { TransitionChild } from '@headlessui/react';
import { useEmcStore } from '@store';

export type SlideModalProps = {
  children: React.ReactNode;
};
export const SlideModal = ({ children }: SlideModalProps) => {
  return (
    <>
      <BackgroundLayer />
      <SlideOverLayer>{children}</SlideOverLayer>
    </>
  );
};
const BackgroundLayer = () => (
  <TransitionChild
    enter="transition-opacity ease-in-out duration-500"
    enterFrom="opacity-0"
    enterTo="opacity-100"
    leave="transition-opacity ease-in-out duration-500"
    leaveFrom="opacity-100"
    leaveTo="opacity-0">
    <div className="fixed inset-0 bg-fuji-800/25 backdrop-blur-md z-20" />
  </TransitionChild>
);

const SlideOverLayer = ({ children }: { children: React.ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null);
  const openEmcSection = useEmcStore(state => state.openEmcSection);

  useEffect(() => {
    if (openEmcSection) {
      const timer = setTimeout(() => {
        ref.current?.scrollTo(0, 0);
      }, 1);
      return () => clearTimeout(timer);
    }
  }, [openEmcSection]);

  return (
    <TransitionChild
      enter="transform transition ease-in-out duration-500"
      enterFrom="translate-y-full"
      enterTo="translate-y-0"
      leave="transform transition ease-in-out duration-500 delay-100"
      leaveFrom="translate-x-0"
      leaveTo="translate-y-full">
      <div className="fixed inset-0 overflow-hidden z-30 rounded-2xl">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pt-12">
            <div className="pointer-events-auto w-screen">
              <div
                ref={ref}
                id="slide-modal-content"
                className="flex h-full flex-col overflow-y-auto overflow-x-hidden bg-mono-100 shadow-xl rounded-2xl">
                <div className="h-full px-4 sm:px-6">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TransitionChild>
  );
};
